export const titlesEnum = Object.freeze({
	projeto: "projeto",
	apikey: "apikey",
	all: "todos"
});
